import { Logger } from "../logger";

export interface ICookieManager {
  saveObject<T>(key: string, object: T, domain?: string): void;
  getObject<T>(key: string): T | null;
  removeObject(key: string, domain?: string): void;
}

export class CookieManager implements ICookieManager {
  private static _instance: ICookieManager;
  public static get Instance() {
    return this._instance || (this._instance = new this());
  }

  /**
   * Retrieve an object by giving a key
   * @param name
   */
  getObject<T>(name: string): T | null {
    const cookies = document.cookie.split("; ");
    for (const cookie of cookies) {
      const [key, value] = cookie.split("=");
      if (key === name) {
        return value as T;
      }
    }
    return null;
  }

  /**
   * Save an object with a key
   * @param key
   * @param object
   * @param domain
   */
  saveObject<T>(key: string, object: T, domain?: string): void {
    try {
      document.cookie = `${key}=${object}${domain ? "; domain=" + domain : ""};`;
    } catch (e) {
      Logger.getInstance().error(String(e));
    }
  }

  /**
   * Remove an object by giving a key
   * @param key
   * @param domain
   */
  removeObject(key: string, domain?: string) {
    try {
      document.cookie = `${key}=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/${domain ? "; domain=" + domain : ""};`;
    } catch (e) {
      Logger.getInstance().error(String(e));
    }
  }
}
